import useMultiLanguage from "../../../../hook/useMultiLanguage";
import TableCollapseCustom, { columnNamesCollapseType } from "../../table-collapse-custom/TableCollapseCustom";

interface Iprops {
  setSelectedData: any;
  selectedData: Array<any>;
  setDataChecked: any;
  prefixNameChildren?: string;
  columnsCustom?: columnNamesCollapseType[];
}

function EmployeeSelectedTable(props: Iprops) {
  const { lang } = useMultiLanguage();
  const { selectedData, setDataChecked, setSelectedData, prefixNameChildren = "listEmployee", columnsCustom } = props;

  const columns: columnNamesCollapseType[] = columnsCustom
    ? [...columnsCustom]
    : [
        {
          name: lang("INPUT.CODE"),
          field: "custom",
          headerCellProps: {
            minWidth: "200px"
          },
          bodyCellProps: {
            textAlign: "left"
          },
          render: (row: any) => (
            <span>
              <p className="color-steel-blue fw-600 spaces p-0 m-0">{row?.maNhanVien}</p>
              <p className="spaces p-0 m-0">{row?.name}</p>
            </span>
          )
        },
        {
          name: lang("INPUT.SALARY.POSITION"),
          field: "chucVuText",
          headerCellProps: {
            minWidth: "200px"
          },
          bodyCellProps: {
            textAlign: "left"
          }
        },
        {
          name: lang("GENERAL.EMPLOYEE.TITLE"),
          field: "viTriCongViecText",
          headerCellProps: {
            minWidth: "200px"
          },
          bodyCellProps: {
            textAlign: "left"
          }
        }
      ];

  return (
    <div className="table-modal-h">
      <TableCollapseCustom
        columnNameList={columns}
        data={selectedData}
        nameParent="phongBanText"
        nameChildren={prefixNameChildren}
        selectData={setDataChecked}
        setData={setSelectedData}
        selectionMode="multiple"
        isSelect={true}
        noToolbar={true}
        uniquePrefix="employeeId"
      />
    </div>
  );
}

export default EmployeeSelectedTable;
